import { alexTrebek } from "./alexTrebek";
import { barackTrudeau } from "./barackTrudeau";
import { buzzLightyear } from "./buzzLightyear";
import { calebCancelled } from "./calebCancelled";
import { candaceCancelled } from "./candaceCancelled";
import { jamesKirk } from "./jamesKirk";
import { deeReynolds } from "./deeReynolds";
import { dennisReynolds } from "./dennisReynolds";
import { dukeCaboom } from "./dukeCaboom";
import { frankReynolds } from "./frankReynolds";
import { jakeFromStateFarm } from "./jakeFromStateFarm";
import { janeDoe } from "./janeDoe";
import { jayLeno } from "./jayLeno";
import { johnDoe } from "./johnDoe";
import { jonHomeless } from "./jonHomeless";
import { katyLetterkenny } from "./katyLetterkenny";
import { lebronJames } from "./lebronJames";
import { maddieDuncan } from "./maddieDuncan";
import { markNobroker } from "./markNobroker";
import { maryNobroker } from "./maryNobroker";
import { matDuncan } from "./matDuncan";
import { michaelJordan } from "./michaelJordan";
import { MockPersona, MockPersonaKey } from "./mockPersonas.types";
import { jeanLucPicard } from "./jeanLucPicard";
import { noFace } from "./noFace";
import { patrickMahomes } from "./patrickMahomes";
import { sidneyCrosby } from "./sidneyCrosby";
import { squirrelyDan } from "./squirrelyDan";
import { tedNoPolicies } from "./tedNopolicies";
import { tomNoPolicies } from "./tomNopolicies";
import { wayneGretzky } from "./wayneGretzky";
import { wayneLetterkenny } from "./wayneLetterkenny";

export * from "./mockPersonas.types";

export const mockPersonas: Map<MockPersonaKey, MockPersona> = new Map<MockPersonaKey, MockPersona>([
  [alexTrebek.key, alexTrebek],
  [barackTrudeau.key, barackTrudeau],
  [buzzLightyear.key, buzzLightyear],
  [calebCancelled.key, calebCancelled],
  [candaceCancelled.key, candaceCancelled],
  [jamesKirk.key, jamesKirk],
  [deeReynolds.key, deeReynolds],
  [dennisReynolds.key, dennisReynolds],
  [dukeCaboom.key, dukeCaboom],
  [frankReynolds.key, frankReynolds],
  [jakeFromStateFarm.key, jakeFromStateFarm],
  [janeDoe.key, janeDoe],
  [jayLeno.key, jayLeno],
  [johnDoe.key, johnDoe],
  [katyLetterkenny.key, katyLetterkenny],
  [jonHomeless.key, jonHomeless],
  [lebronJames.key, lebronJames],
  [maddieDuncan.key, maddieDuncan],
  [markNobroker.key, markNobroker],
  [maryNobroker.key, maryNobroker],
  [matDuncan.key, matDuncan],
  [michaelJordan.key, michaelJordan],
  [jeanLucPicard.key, jeanLucPicard],
  [noFace.key, noFace],
  [patrickMahomes.key, patrickMahomes],
  [sidneyCrosby.key, sidneyCrosby],
  [squirrelyDan.key, squirrelyDan],
  [tedNoPolicies.key, tedNoPolicies],
  [tomNoPolicies.key, tomNoPolicies],
  [wayneGretzky.key, wayneGretzky],
  [wayneLetterkenny.key, wayneLetterkenny],
]);
